module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "report"
  }, [_c('PageTitle', {
    attrs: {
      "pagetitle": "搜索分析",
      "tip": "帮助您了解互联网用户对搜索词的关注程度及变化趋势；找到与核心搜索词相关性高的热门搜索词，优化搜索推广策略，提升广告效果"
    }
  }), _c('div', {
    staticClass: "time"
  }, [_c('TimeSpan', {
    attrs: {
      "filters": "7a"
    },
    on: {
      "change": _vm.onTimespanChange
    }
  })], 1), _c('div', {
    staticClass: "zone"
  }, [_c('TableTitle', {
    attrs: {
      "icon": "fa fa-signal",
      "title": "趋势图"
    }
  }), _c('LineChart', {
    attrs: {
      "legend": _vm.legend,
      "xAxis": _vm.chartXAxis,
      "series": _vm.chartSeries
    }
  })], 1), _c('div', {
    staticClass: "zone"
  }, [_c('TableTitle', {
    attrs: {
      "icon": "fa fa-list",
      "title": _vm.tableTabTitle
    }
  }), _c('div', {
    staticClass: "nav-tabs"
  }, [_c('TabContent', {
    attrs: {
      "title": "主维度：",
      "tablist": _vm.tablist,
      "update": _vm.updateTab
    }
  }, [(_vm.total > 0) ? _c('DownloadBtn', {
    attrs: {
      "reportApi": _vm.reportApi,
      "params": _vm.query,
      "pagetitle": _vm.tableTabTitle,
      "subtitle": ""
    },
    slot: "extentTab"
  }) : _vm._e(), _c('div', {
    slot: "keyword"
  }, [_c('p', {
    staticClass: "plan-nav"
  }, [_vm._v("选择二级维度："), _c('v-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sdim),
      expression: "sdim"
    }],
    attrs: {
      "name": "secondaryDim",
      "options": _vm.sdimOptions
    },
    domProps: {
      "value": (_vm.sdim)
    },
    on: {
      "input": function($event) {
        _vm.sdim = $event
      }
    },
    nativeOn: {
      "change": function($event) {
        _vm.sdimChange($event)
      }
    }
  })], 1), _c('div', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "label-inline"
  }, [_vm._v("搜索词：")]), _c('div', {
    staticClass: "control"
  }, [_vm._l((_vm.keywordList), function(item, index) {
    return _c('div', {
      staticClass: "input-item"
    }, [_c('v-input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.value),
        expression: "item.value"
      }],
      attrs: {
        "placeholder": "请输入搜索词（最多10个）"
      },
      domProps: {
        "value": (item.value)
      },
      on: {
        "input": function($event) {
          item.value = $event
        }
      },
      nativeOn: {
        "input": function($event) {
          _vm.pushKeyword($event, item)
        }
      }
    }), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index != 0),
        expression: "index != 0"
      }],
      staticClass: "fa fa-close",
      on: {
        "click": function($event) {
          _vm.removeKeyword(index)
        }
      }
    })], 1)
  }), _c('div', {
    staticClass: "input-add-item"
  }, [_c('button', {
    staticClass: "btn add-btn",
    attrs: {
      "disabled": _vm.keywordList.length == 10
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.addKeyword($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("添加搜索词")]), _c('button', {
    staticClass: "btn btn-primary btn-small",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.searchKeyword($event)
      }
    }
  }, [_vm._v("确定 ")])])], 2)])]), _c('div', {
    slot: "province"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("添加搜索词：")]), _c('div', {
    staticClass: "control"
  }, [_c('v-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.provinceKeyword),
      expression: "provinceKeyword"
    }],
    attrs: {
      "placeholder": "请输入一个关键词"
    },
    domProps: {
      "value": (_vm.provinceKeyword)
    },
    on: {
      "input": function($event) {
        _vm.provinceKeyword = $event
      }
    }
  })], 1)]), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label-inline"
  }, [_vm._v("选择地域：")]), _c('div', {
    staticClass: "control"
  }, [_c('ul', [_vm._l((_vm.provinces), function(province, index) {
    return _c('li', {
      key: province.id,
      staticClass: "province",
      class: {
        active: province.active
      },
      on: {
        "click": function($event) {
          _vm.selectProvince(province, index)
        }
      }
    }, [_vm._v(_vm._s(province.value))])
  }), _c('li', {
    staticClass: "province btn-primary white btn-small",
    class: {
      gray: _vm.provinceSearchDisabled
    },
    on: {
      "click": _vm.searchKeyword
    }
  }, [_vm._v("确定")])], 2)])])]), _c('div', {
    slot: "common"
  }, [_c('p', {
    staticClass: "tabAction"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.fetchLineChartabled
    },
    on: {
      "click": _vm.fetchLineChartData
    }
  }, [_vm._v("绘制选定行")])])])], 1)], 1), _c('complex-table', {
    attrs: {
      "classname": 'bluethead opt-table',
      "columns": _vm.columns,
      "list": _vm.tableDataList,
      "sum": {},
      "checkbox": _vm.hasCheckBox,
      "checkbox_length": _vm.checkboxLength
    }
  }, [_c('v-tooltip', {
    attrs: {
      "tip": '对各关键词在360搜索中搜索频次数据进行加权计算，反映某关键词的搜索规模',
      "pos": "right"
    },
    slot: "snum"
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    staticStyle: {
      "margin-left": "5px"
    }
  })])], 1), (_vm.total > _vm.ps) ? _c('v-pagination', {
    attrs: {
      "total": _vm.total,
      "pn": _vm.pg,
      "ps": _vm.ps
    },
    on: {
      "updatepage": _vm.getTableData
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-21483902", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-21483902!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pageview/web/search.vue
// module id = 728
// module chunks = 0